export enum MixpanelEvents {
  PROMO_CODE_REMOVED = 'PROMO_CODE_REMOVED',
  SAVED_CARD_SELECTED = 'SAVED_CARD_SELECTED',
  SAVED_CARD_REMOVED = 'SAVED_CARD_REMOVED',
  CHECKOUT_SECTION_STATE_CHANGED = 'CHECKOUT_SECTION_STATE_CHANGED',
  NEW_CARD_PAYMENT = 'NEW_CARD_PAYMENT',
  CHECKOUT_PRESENTED = 'CHECKOUT_PRESENTED',
  CHECKOUT_OPENED = 'CHECKOUT_OPENED',
  PAY_BUTTON_CLICKED = 'ON_PAY_BUTTON_CLICKED',
  COUPON_APPLIED = 'COUPON_APPLIED',
  CHECKOUT_CLOSED = 'CHECKOUT_CLOSED',
  ADD_OR_CHANGE_CARD_CLICKED = 'ADD_OR_CHANGE_CARD_CLICKED',
  PAYMENT_NOT_SUPPORTED = 'PAYMENT_NOT_SUPPORTED',
  PAY_CTA_PULSE_RENDERED = 'pay_cta_pulse_rendered',
  USE_OTHER_PAYMENT_METHOD_CLICKED = 'ON_USE_OTHER_PAYMENT_METHOD_CLICKED',
  APPLE_PAY_TAB_FALLBACK_RENDERED = 'APPLE_PAY_TAB_FALLBACK_RENDERED',
  APPLE_PAY_TAB_FALLBACK_CLICKED = 'APPLE_PAY_TAB_FALLBACK_CLICKED',
  APPLE_PAY_TAB_FALLBACK_TAB_CLOSED = 'APPLE_PAY_TAB_FALLBACK_TAB_CLOSED',
  CARD_ENTRY_STARTED = 'CARD_ENTRY_STARTED',
  FORM_ENTRY_COMPLETED = 'FORM_ENTRY_COMPLETED',
  PAYMENT_CHOOSE = 'PAYMENT_CHOOSE',
}
